import { render } from "preact";
import { App } from "./app";
import { applyPrefs } from "./prefs";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/pages.css";
import "./styles/builder.css";

applyPrefs();
render(<App />, document.getElementById("app")!);
